import ReactDOM from 'react-dom';

const PopupPortal = ({ children }) => {
    if (__isBrowser__) {
        return ReactDOM.createPortal(children, document.body);
    }
    return null;
};
export default PopupPortal;
